import { render } from "./UltrasoundView.vue?vue&type=template&id=062928e5&scoped=true"
import script from "./UltrasoundView.vue?vue&type=script&lang=js"
export * from "./UltrasoundView.vue?vue&type=script&lang=js"

import "./UltrasoundView.vue?vue&type=style&index=0&id=062928e5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062928e5"]])

export default __exports__